import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import moment from 'moment';
import { get } from 'lodash';
export default function PlacementTestReportStudentsList(props) {
  return (
    <Table
      fetching={props.isFetching}
      columns={[
        {
          label: 'Student',
          path: 'student.name',
          sort: true,
        },
        {
          label: 'Email',
          path: 'student.email',
          sort: true,
        },
        {
          label: 'Level',
          path: 'reachedLevel.level',
          render: (_, row) => get(row, 'course.name', '-'),
          sort: (a, b) => {
            if (props.sort.order === 'ascend') {
              return a < b;
            }
            return a > b;
          },
        },
        {
          label: 'Execution date',
          path: 'startedAt',
          render: (value) => moment(value).format('DD/MM/YYYY HH:mm'),
          sort: true,
          defaultSortOrder: 'descend',
        },
        {
          label: 'Execution time',
          path: 'duration',
          render: (value) => {
            if (!value) {
              return '-';
            }
            return moment.duration(value).format('*hh:mm:ss');
          },
          sort: true,
        },
        {
          label: 'Hits',
          path: 'correctItems',
          render: (value, row) =>
            get(row, 'answeredItems', []).length > 0
              ? `${value}/${row.answeredItems.length} (${((value / row.answeredItems.length) * 100).toFixed(1)}%)`
              : `${value}/${row.answeredItems.length}`,
          sort: true,
        },
        {
          label: 'Details',
          width: '100px',
          path: 'id',
          render: (value) => <Button icon="eye" onClick={() => props.onOpen(value)} />,
        },
      ]}
      pagination={props.pagination}
      onChange={props.onChange}
      rows={props.data}
    />
  );
}

PlacementTestReportStudentsList.propTypes = {
  data: PropTypes.array.isRequired,
  isFetching: PropTypes.bool,
  pagination: PropTypes.shape({
    current: PropTypes.number,
    total: PropTypes.number,
    pageSize: PropTypes.number,
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  onOpen: PropTypes.func.isRequired,
  sort: PropTypes.object.isRequired,
};

PlacementTestReportStudentsList.defaultProps = {
  isFetching: false,
};
